import { render, staticRenderFns } from "./QuizDetail.vue?vue&type=template&id=49ab9491&scoped=true"
import script from "./QuizDetail.vue?vue&type=script&lang=js"
export * from "./QuizDetail.vue?vue&type=script&lang=js"
import style0 from "./QuizDetail.vue?vue&type=style&index=0&id=49ab9491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab9491",
  null
  
)

export default component.exports